import { Star } from "lucide-react";

const SOFTWARE = ["All", "Notion", "Excel", "Figma", "PowerPoint", "Google Sheets", "Canva"];
const TIERS = ["All", "Free", "Pro", "Premium"];
const RATINGS = [
  { label: "All ratings", value: 0 },
  { label: "4.5+", value: 4.5 },
  { label: "4.7+", value: 4.7 },
  { label: "4.8+", value: 4.8 },
];

export const FilterSidebar = ({ filters, setFilters }) => {
  const update = (key, value) => setFilters((f) => ({ ...f, [key]: value }));

  return (
    <aside data-testid="filter-sidebar" className="border border-white/10 bg-slate-900">
      <div className="border-b border-white/10 p-6">
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">
          Refine
        </span>
        <h3 className="mt-1 font-display text-xl font-bold tracking-tight text-white">Filters</h3>
      </div>

      {/* Software type */}
      <div className="border-b border-white/10 p-6">
        <p className="mb-3 font-mono text-xs uppercase tracking-[0.15em] text-slate-400">
          Software Type
        </p>
        <div className="flex flex-col gap-1">
          {SOFTWARE.map((s) => (
            <button
              key={s}
              data-testid={`filter-software-${s.replace(/\s/g, "-").toLowerCase()}`}
              onClick={() => update("software", s)}
              className={`px-3 py-2 text-left text-sm transition-colors duration-200 ${
                filters.software === s
                  ? "bg-emerald-500 font-semibold text-slate-900"
                  : "text-slate-300 hover:bg-white/5"
              }`}
            >
              {s}
            </button>
          ))}
        </div>
      </div>

      {/* Pricing tier */}
      <div className="border-b border-white/10 p-6">
        <p className="mb-3 font-mono text-xs uppercase tracking-[0.15em] text-slate-400">
          Pricing Tier
        </p>
        <div className="grid grid-cols-2 gap-2">
          {TIERS.map((t) => (
            <button
              key={t}
              data-testid={`filter-tier-${t.toLowerCase()}`}
              onClick={() => update("tier", t)}
              className={`border px-3 py-2 text-sm transition-colors duration-200 ${
                filters.tier === t
                  ? "border-emerald-500 text-emerald-300"
                  : "border-white/10 text-slate-300 hover:border-white/30"
              }`}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      {/* Rating */}
      <div className="p-6">
        <p className="mb-3 font-mono text-xs uppercase tracking-[0.15em] text-slate-400">
          Minimum Rating
        </p>
        <div className="flex flex-col gap-1">
          {RATINGS.map((r) => (
            <button
              key={r.value}
              data-testid={`filter-rating-${r.value}`}
              onClick={() => update("min_rating", r.value)}
              className={`flex items-center gap-2 px-3 py-2 text-left text-sm transition-colors duration-200 ${
                filters.min_rating === r.value
                  ? "bg-white/10 text-white"
                  : "text-slate-300 hover:bg-white/5"
              }`}
            >
              {r.value > 0 && <Star className="h-3.5 w-3.5 fill-emerald-400 text-emerald-400" />}
              {r.label}
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default FilterSidebar;
